import { render, staticRenderFns } from "./MainBalance.vue?vue&type=template&id=3da57f56&scoped=true&"
import script from "./MainBalance.vue?vue&type=script&lang=js&"
export * from "./MainBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da57f56",
  null
  
)

export default component.exports